<template>
  <b-overlay :show="loading">
    <div
      :class="{ selected: receipt.comprobanteId === selectedReceipt }"
      class="row p-3 mt-2 shadow-sm bg-white"
    >
      <div data-cy="file" class="col-11">
        <div class="row">
          <div class="col-2 text-center text-primary">
            <div
              v-tooltip="'Folio'"
              :class="{ 'text-success': wasCopied }"
              class="cursor-pointer"
            >
              {{receipt.folio}}
            </div>
            <b-form-checkbox
              v-if="showCheck"
              v-model="receipt.selected"
              @change="selectElement"
            />
          </div>
          <div class="col-2">
            <vs-chip
              :color="receiptsStates[receipt.estado].color"
              v-if="receiptsStates[receipt.estado]"
              v-tooltip="`${receiptsStates[receipt.estado].label}`"
            >
              {{receiptsStates[receipt.estado].label}}
            </vs-chip>
          </div>
          <div class="col-8">
            <div class="row">
              <div class="col-3">
                {{receipt.adjudicatarios.nombre}}
                <br>
                <small>{{receipt.adjudicatarios.rut}}</small>
              </div>
              <div class="col-2">
                {{receipt.fechaCreacion | dateFormat}}
              </div>
              <div class="col-5">
                {{receipt.subasta.gestora.razonSocial}}
                <br>
                <small>
                  {{receipt.subasta.gestora.rut}}
                </small>
              </div>
              <div class="col-2">
                <b>
                  {{receipt.montoTotal | amount}}
                </b>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-11 offset-1">
            <vs-chip
              class="mr-4"
              color="primary"
              v-tooltip="'Folio Subasta'"
            >
              <vs-avatar icon="gavel" />
              {{ receipt.subasta.folio }}
            </vs-chip>
            <vs-chip
              class="mr-4"
              color="green"
              v-tooltip="'Folio Lote'"
            >
              <vs-avatar icon="local_offer" />
              {{ receipt.lote.folio }}
            </vs-chip>
            <vs-chip
              class="mr-4"
              color="primary"
              v-tooltip="'Posición Subasta'"
            >
              <vs-avatar icon="location_on" />
              {{
                `${receipt.lote.loteadora.codigo}
                -${receipt.subasta.gestora.codigoAduana}
                -${receipt.lote.folio}-${receipt.lote.posicion}`
              }}
            </vs-chip>
            <vs-chip
              class="mr-4"
              color="#7d84ad"
              v-tooltip="'Monto de garantía'"
            >
              <vs-avatar icon="monetization_on" />
              {{ receipt.garantiaMonto | amount }}
            </vs-chip>
            <vs-chip
              v-if="receipt.fechaMaximaPago"
              color="#ff9800"
              class="mr-4"
              v-tooltip="'Fecha máxima de pago'"
            >
              <vs-avatar icon="date_range" />
              {{ receipt.fechaMaximaPago | dateFormat }}
            </vs-chip>
          </div>
        </div>
      </div>
      <div class="col-1 d-flex justify-center">
        <slot name="actions" v-bind:receipt="receipt">
          <ReceiptsOptions
            :ref="'file-options-' + receipt.comprobanteId"
            :receipt="receipt"
            :select-receipt="selectReceipt"
            v-on:reload-list="handleReloadList"
          />
        </slot>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ReceiptsOptions from '@/febos/aduanas/receipts/views/components/ReceiptsOptions';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import { receiptsStates } from '@/febos/aduanas/receipts/views/utils/constants';

export default {
  components: { ReceiptsOptions },
  mixins: [CopyToClipboard],
  data() {
    return {
      loading: false,
      receiptsStates
    };
  },
  props: [
    'receipt',
    'selectReceipt',
    'isMassive',
    'selectedReceipts'
  ],
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('receipts', ['selectedReceipt']),
    showCheck() {
      if (this.selectedReceipts.length) {
        if (!this.isMassive) {
          return this.receipt.adjudicatarios.rut === this.selectedReceipts[0].adjudicatarios.rut;
        }
        return true;
      }
      return true;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    selectElement() {
      if (this.receipt.selected) {
        this.$emit('select-check-receipt', this.receipt);
        return;
      }
      this.$emit('unselect-check-receipt', this.receipt);
    },
    handleReloadList() {
      this.$emit('reload-list');
    }
  }
};

</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}
.mother-indicator{
  width:160px;
  margin-left:50%;
  left: 80px;
}
</style>
